import { render, staticRenderFns } from "./ParameterDetail.vue?vue&type=template&id=0c4edf40&scoped=true&"
import script from "./ParameterDetail.vue?vue&type=script&lang=js&"
export * from "./ParameterDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c4edf40",
  null
  
)

export default component.exports